import styles from './Footer.module.css';
import { ReactNode } from 'react';

// Пропсы для контакта
interface Contact {
  label: string; // необязательно, можно не показывать
  value: string;
  href: string | null;
}

// Пропсы для соцсети
interface Social {
  name: string;
  url: string;
  icon: ReactNode;
}

// Все пропсы компонента
interface FooterProps {
  slogan: string;
  contacts: Contact[];
  socials: Social[];
  copyright?: string;
}

const Footer = ({ slogan, contacts, socials, copyright = `© ${new Date().getFullYear()} YourBrand. Все права защищены.` }: FooterProps) => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Центральный слоган */}
        <p className={styles.slogan}>{slogan}</p>

        {/* Контакты + Соцсети в строке */}
        <div className={styles.contactRow}>
          {/* Контакты */}
          <div className={styles.contacts}>
            {contacts.map((contact, i) => (
              <span key={i}>
                {contact.href ? (
                  <a href={contact.href} target="_blank" rel="noopener noreferrer">
                    {contact.value}
                  </a>
                ) : (
                  <span>{contact.value}</span>
                )}
              </span>
            ))}
          </div>

          {/* Соцсети */}
          <div className={styles.socials}>
            {socials.map((social, i) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Копирайт */}
      <div className={styles.copyright}>{copyright}</div>
    </footer>
  );
};

export default Footer;
